import "../../styles/strategiesInfo.css";

export default function NotesInfo({ onClose }) {
  return (
    <div className="info-backdrop" onClick={onClose}>
      <div className="info-modal" onClick={e => e.stopPropagation()}>

        <button className="info-close" onClick={onClose}>✕</button>

        <h2>Jegyzetek működése</h2>

        <p className="info-lead">
          A jegyzetek arra szolgálnak, hogy megfigyeléseidet,
          gondolataidat és fontos információkat rögzíts egy adott csapathoz
          vagy mérkőzéshez kapcsolódóan.
        </p>

        <ul className="info-list">
          <li>
            📝 <strong>Szabad jegyzetelés</strong> – Bármikor létrehozhatsz jegyzetet,
            amikor észreveszel valami relevánsat egy csapattal kapcsolatban
            (forma, hiányzók, taktikai változás stb.).
          </li>
          <li>
            🔍 <strong>Visszatérhető megfigyelések</strong> – A jegyzetek segítenek
            abban, hogy később is emlékezz azokra a tényezőkre,
            amelyek egy adott meccsnél fontosak lehetnek.
          </li>
          <li>
            🧠 <strong>Tudatos döntéstámogatás</strong> – Nem konkrét fogadások,
            hanem előzetes gondolatok kerülnek ide, amelyek támogatják
            a mérkőzés előtti döntéshozatalt.
          </li>
        </ul>

        <p className="info-footnote">
          💡 Tipp: Ha rendszeresen vezetsz jegyzeteket a csapatokról,
          idővel saját adatbázist építesz, amely komoly előnyt jelenthet
          a fogadások előtti elemzésnél.
        </p>



      </div>
    </div>
  );
}

{/* <div className="info-video">
  <iframe
    src="https://www.youtube.com/embed/VIDEÓ_ID"
    title="Hogyan működik"
    allowFullScreen
  />
</div> */}